import RestClient from '@/api/api';
import { captureTokenFromResponse, clearToken } from '@/utilities/token';

class AuthApi extends RestClient {
  constructor() {
    super(false); // Auth endpoints don't require authentication
  }

  baseUrl() {
    // Auth endpoints are not under /api/v1, just use the base domain
    return document.querySelector('meta[name="api-root-endpoint"]')?.getAttribute('content')?.replace('/api/v1', '') || 'http://localhost:3000'
  }

  async login(email, password) {
    const response = await this.makeRequest('post', '/users/sign_in', { user: { email, password } });

    captureTokenFromResponse(response);
    return response;
  }

  async register(email, password, passwordConfirmation) {
    return await this._post('/users', { user: { email, password, password_confirmation: passwordConfirmation } });
  }

  async logout() {
    try {
      await this._delete('/users/sign_out');
    } finally {
      clearToken();
    }
  }

  async resendConfirmation(email) {
    return await this._post('/users/confirmation', { user: { email } });
  }

  async confirmAccount(confirmationToken) {
    const response = await this.makeRequest('get', `/users/confirmation?confirmation_token=${confirmationToken}`);

    captureTokenFromResponse(response);
    return response;
  }

  async requestUnlock(email) {
    return await this._post('/users/unlock', { user: { email } });
  }

  async unlockAccount(unlockToken) {
    return await this._get(`/users/unlock?unlock_token=${unlockToken}`);
  }

  async requestPasswordReset(email) {
    return await this._post('/users/password', { user: { email } });
  }

  async resetPassword(resetPasswordToken, password, passwordConfirmation) {
    const response = await this.makeRequest('put', '/users/password', { user: { reset_password_token: resetPasswordToken, password, password_confirmation: passwordConfirmation } });

    captureTokenFromResponse(response);
    return response;
  }
}

export default new AuthApi();
